import monitor from '@blaze-cms/plugin-monitor';
import serverMonitors from '@blaze-cms/plugin-monitor/src/server-monitors';
import sentry from '@blaze-cms/plugin-sentry/src/utils/browser';
import datadogApm from '@blaze-cms/plugin-datadog-apm/src/utils/ui';
import authAbacusFe from '@blaze-cms/plugin-auth-abacus-fe';
import shorthand from '@blaze-cms/plugin-shorthand-fe';
import chart from '@blaze-cms/plugin-chart';
import dxpPlugin from '@blaze-cms/plugin-dxp-fe';
import posthogPlugin from '@blaze-cms/plugin-dxp-posthog-fe';
import boatContentPlugin from './blaze-plugins/boat-content';
import listQueryVariablesPlugin from './blaze-plugins/list-query-variables-plugin';
import { CHART_COLOURS } from './constants';

export default function buildConfig(config) {
  serverMonitors('frontend', [sentry, datadogApm]); // If required environment not set, sentry will not log anything.

  config.plugins.set(monitor, {});

  // To set custom plugins into the project.
  config.plugins.set(boatContentPlugin, {});
  config.plugins.set(authAbacusFe, {});
  config.plugins.set(shorthand, {});
  config.plugins.set(listQueryVariablesPlugin, {});
  config.plugins.set(chart, {
    defaultColourScheme: CHART_COLOURS.ONE,
    datasetsColourSchemes: [...Object.values(CHART_COLOURS)]
  });
  config.plugins.set(dxpPlugin, {});
  config.plugins.set(posthogPlugin, {
    personalisationStrategyOptions: {
      moreLikeThis: {
        fields: [
          'builderProfileIds.keyword',
          'hullBuilderProfileIds.keyword',
          'brokerIds.keyword',
          'yachtCategoryIds.keyword',
          'categoryId.keyword'
        ],
        min_term_freq: 1,
        min_doc_freq: 1
      }
    }
  });

  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };
  return config;
}
